module.exports = __webpack_public_path__ + "static/media/gothic.b02d441e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothic.woff
// module id = 265
// module chunks = 1